import { curriedDeleteSessiion_sRecordingFile } from "./functions/cloudRecording/deleteSession-sRecordingFile";
import { curriedDeleteSessiion_sRecordings } from "./functions/cloudRecording/deleteSession-sRecordings";
import { curriedListRecordingsOfAnAccount } from "./functions/cloudRecording/listRecordingsOfAnAccount";
import { curriedListSession_sRecordings } from "./functions/cloudRecording/listSession-sRecordings";
import { curriedRecoverASingleRecording } from "./functions/cloudRecording/recoverASingleRecording";
import { curriedRecoverSession_sRecordings } from "./functions/cloudRecording/recoverSession-sRecordings";
import { curriedGetSessionDetails } from "./functions/sessions/getSessionDetails";
import { curriedGetSessionLiveStreamDetails } from "./functions/sessions/getSessionLiveStreamDetails";
import { curriedGetSessionUserQos } from "./functions/sessions/getSessionUserQoS";
import { curriedGetSharingRecordingDetails } from "./functions/sessions/getSharingRecordingDetails";
import { curriedListSessionUsers } from "./functions/sessions/listSessionUsers";
import { curriedListSessionsUsersQos } from "./functions/sessions/listSessionUsersQoS";
import { curriedListSessions } from "./functions/sessions/listSessions";
import { curriedUpdateASessionLiveStream } from "./functions/sessions/updateASessionLiveStream";
import { curriedUpdateSessionLivestreamStatus } from "./functions/sessions/updateSessionLivestreamStatus";
import { curriedUpdateSessionStatus } from "./functions/sessions/updateSessionStatus";
import { curriedUseIn_SessionEventsControls } from "./functions/sessions/useIn-SessionEventsControls";
import { curriedGetCloudRecordingUsageReport } from "./functions/videoSDKReports/getCloudRecordingUsageReport";
import { curriedGetDailyUsageReport } from "./functions/videoSDKReports/getDailyUsageReport";
import { curriedGetOperationLogsReport } from "./functions/videoSDKReports/getOperationLogsReport";
import { curriedGetTelephoneReport } from "./functions/videoSDKReports/getTelephoneReport";
import { generateAPIToken } from "./utils";



export const createZoomVideoSdkApiClient = ({
	apiKey,
	apiSecret,
}: { apiKey: string; apiSecret: string }) => {
	const token = generateAPIToken({
		APIKey: apiKey,
		APISecret: apiSecret,
	});
	return {
		// CloudRecordings
		deleteSessiion_sRecordingFile: curriedDeleteSessiion_sRecordingFile(token),
		deleteSessiion_sRecordings: curriedDeleteSessiion_sRecordings(token),
		listRecordingsOfAnAccount: curriedListRecordingsOfAnAccount(token),
		listSession_sRecordings: curriedListSession_sRecordings(token),
		recoverASingleRecording: curriedRecoverASingleRecording(token),
		recoverSession_sRecordings: curriedRecoverSession_sRecordings(token),

		// Sessions
		getSessionDetails: curriedGetSessionDetails(token),
		getSessionLiveStreamDetails: curriedGetSessionLiveStreamDetails(token),
		getSessionUserQos: curriedGetSessionUserQos(token),
		getSharingRecordingDetails: curriedGetSharingRecordingDetails(token),
		listSessionUsers: curriedListSessionUsers(token),
		listSessionUsersQoS: curriedListSessionsUsersQos(token),
		listSessions: curriedListSessions(token),
		updateASessionLiveStream: (curriedUpdateASessionLiveStream)(token),
		updateSessionLivestreamStatus: (curriedUpdateSessionLivestreamStatus)(token),
		updateSessionStatus: (curriedUpdateSessionStatus)(token),
		useIn_SessionEventsControls: (curriedUseIn_SessionEventsControls)(token),

		// VideoSDKReports
		getCloudRecordingUsageReport: (curriedGetCloudRecordingUsageReport)(token),
		getDailyUsageReport: (curriedGetDailyUsageReport)(token),
		getOperationLogsReport: (curriedGetOperationLogsReport)(token),
		getTelephoneReport: (curriedGetTelephoneReport)(token),
	};
};
